import { BrokerTypes } from "../graphql/__generated__/globalTypes";

export const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";

export const urls = {
  [BrokerTypes.Irisk]: process.env.REACT_APP_IRISK_URL,
  [BrokerTypes.Visal]: process.env.REACT_APP_VISAL_URL,
  [BrokerTypes.Kek]: process.env.REACT_APP_KEK_URL,
  [BrokerTypes.Placeit]: process.env.REACT_APP_PLACE_IT_ASSET_URI,
};
